import React from 'react';
import {Button, Col, Divider, Form, Row, Typography} from 'antd';
import * as Yup from 'yup';
import {Formik} from "formik";
import {
  CheckboxInput,
  CodeTreeFastInput,
  DateInput,
  TemperatureRangeInput,
  TextAreaInput,
  TextInput
} from "../../Boilerplate/formikComponents";
import {cloneDeep} from "lodash";
import moment from "moment";
import * as R from 'ramda';

export const DailyLogForm = props => {
  const { dailyLog, onCancel, onSubmit } = props;
  let initials, edit = false;
  if (dailyLog) {
    initials = cloneDeep(dailyLog);
    edit = true;
    initials['hasvisitors'] = !!initials['visitors'];
    initials['hassubcontractors'] = !!initials['subcontractors'];
    initials['hasequipment'] = !!initials['equipment'];
  } else {
    initials = {
      logdate: moment().startOf('day'),
    };
  }
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    }
  };
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };
  return (
    <Formik
      initialValues = {initials}
      onSubmit={(values, { setSubmitting }) => {
        values = cloneDeep(values);
        if (!values['hasvisitors']) values.visitors = null;
        if (!values['hassubcontractors']) values.subcontractors = null;
        if (!values['hasequipment']) values.equipment = null;
        values = R.omit(['hasvisitors', 'hassubcontractors', 'hasequipment'], values);
        onSubmit && onSubmit(values);
      }}
      validationSchema={Yup.object().shape({
        id: Yup.string().nullable(),
        number: Yup.string(),
      })}
    >
      {props => {
        const {
          values,
          handleSubmit,
          handleReset,
        } = props;
        return (
          <Form>
            <TextInput {...props} formItemLayout={formItemLayout} label='Log #' name='number' placeholder='Enter a number'/>
            {!edit && <Row style={{ marginTop: -24, fontSize: 13 }}>
              <Col xs={24} sm={0} style={{ width: 400 }}>
                <Typography><Typography.Paragraph><Typography.Text type={'secondary'}>
                  cProject will auto generate this if left blank. The Daily Log # is intended to be used as a communication
                  reference, written or verbal. [Example: "John, were there weather delays for Daily Log
                  #22?"]</Typography.Text></Typography.Paragraph></Typography>
              </Col>
              <Col xs={0} sm={16} offset={8} style={{ width: 400 }}>
                <Typography><Typography.Paragraph><Typography.Text type={'secondary'}>cProject will auto generate this
                  if left blank. The Daily Log # is intended to be used as a communication reference, written or verbal.
                  [Example: "John, were there weather delays for Daily Log
                  #22?"]</Typography.Text></Typography.Paragraph></Typography>
              </Col>
            </Row>}
            <DateInput {...props} formItemLayout={formItemLayout} label='Log Date' name='logdate'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Summary' name='summary' placeholder='Summary...'/>
            <Divider>Weather Info</Divider>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Weather Details' name='weather' placeholder='Humidity %, sunny, cloudy, etc...'/>
            <TemperatureRangeInput {...props} formItemLayout={formItemLayout} label='Temperature' name='temp'/>
            <Divider>CSI Codes</Divider>
            <CodeTreeFastInput {...props} formItemLayout={formItemLayout} label='CSI Codes' name='csicodes' table='csi_hierarchy'/>
            <Divider>Issues & Delays</Divider>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Safety Issues' name='safetyissues' placeholder='Safety Issues...'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Weather Delays' name='weatherdelays' placeholder='Weather Delays...'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Trade Delays' name='tradedelays' placeholder='Trade Delays...'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Safety Delays' name='safetydelays' placeholder='Safety Delays...'/>
            <TextAreaInput {...props} formItemLayout={formItemLayout} label='Other Delays' name='otherdelays' placeholder='Other Delays...'/>
            <Divider>Additional Information</Divider>
            <CheckboxInput {...props} formItemLayout={formItemLayout} label='Visitors' name='hasvisitors'/>
            {values['hasvisitors'] && <React.Fragment>
              <TextAreaInput {...props} formItemLayout={tailFormItemLayout} name='visitors' placeholder='Visitors...' autosize={{ minRows: 1, maxRows: 6 }}/>
            </React.Fragment>}
            <CheckboxInput {...props} formItemLayout={formItemLayout} label='Subcontractors' name='hassubcontractors'/>
            {values['hassubcontractors'] && <React.Fragment>
              <TextAreaInput {...props} formItemLayout={tailFormItemLayout} name='subcontractors' placeholder='Subcontractors...' autosize={{ minRows: 1, maxRows: 6 }}/>
            </React.Fragment>}
            <CheckboxInput {...props} formItemLayout={formItemLayout} label='Equipment' name='hasequipment'/>
            {values['hasequipment'] && <React.Fragment>
              <TextAreaInput {...props} formItemLayout={tailFormItemLayout} name='equipment' placeholder='Equipment...' autosize={{ minRows: 1, maxRows: 6 }}/>
            </React.Fragment>}

            <Form.Item className='submit-controls' {...tailFormItemLayout}>
              <Button.Group compact>
                <Button onClick={handleSubmit} type='primary'>Save</Button>
                <Button onClick={handleReset}>Clear</Button>
                <Button onClick={onCancel}>Cancel</Button>
              </Button.Group>
            </Form.Item>
          </Form>
        );
      }}
    </Formik>
  );
};


// WEBPACK FOOTER //
// ./src/components/Projects/DailyLogs/DailyLogForm.js